var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.popstateModel ? 'ld-hide-in-fade' : 'ld-hide-fade'},on:{"after-leave":_vm.afterLeave}},[(_vm.visible)?_c('div',{staticClass:"alone-layer ld-dialog-mask",class:{ 'is-fade': _vm.isFade, 'is-absolute': _vm.absolute },on:{"click":function($event){_vm.$emit('update:visible', false)},"touchmove":function($event){$event.preventDefault();}}}):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fbd35d76","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stories/dialog/tool/mask.vue
// module id = null
// module chunks = 